import { AppKey } from '../../app/AppKey';
import { Metrics } from '../../metrics/Metrics';
import AnonymousTrackerContainer from '../../tracking/AnonymousUsageTrackerContainer';
import UsageTrackerContainer from '../../tracking/UsageTrackingContainer';
import { AppActionTypes } from './action-types';
export const updateKeyValue = (key, value) => dispatch => {
  return dispatch({
    type: AppActionTypes.UpdateKeyValue,
    key,
    value
  });
};
export const startApp = () => dispatch => {
  Metrics.counter('signup-initiated').increment();
  return dispatch({
    type: AppActionTypes.AppStarted
  });
};
export const setNewPortalCreated = () => {
  return updateKeyValue(AppKey.IsNewPortalCreated, true);
};
export const setHublet = hublet => {
  return updateKeyValue(AppKey.Hublet, hublet);
};
export const setIsNewUser = isNewUser => {
  return updateKeyValue(AppKey.IsNewUser, isNewUser);
};
export const setIsNewUserCreated = isNewUser => {
  return updateKeyValue(AppKey.IsNewUserCreated, isNewUser);
};
export const setIsOAuthExistingUser = isOAuthExistingUser => {
  return updateKeyValue(AppKey.IsOAuthExistingUser, isOAuthExistingUser);
};
export const completeVerificationComplete = () => {
  return updateKeyValue(AppKey.CompleteVerificationComplete, true);
};
export const setVerificationType = verificationType => dispatch => {
  if (verificationType) {
    UsageTrackerContainer.setProperties({
      verificationType
    });

    if (AnonymousTrackerContainer.isAnonymousTrackingEnabled) {
      AnonymousTrackerContainer.setProperties({
        verificationType
      });
    }
  }

  return dispatch(updateKeyValue(AppKey.VerificationType, verificationType));
};
export const setHasRefreshedNewPortalAuth = hasRefreshedAuth => {
  return updateKeyValue(AppKey.HasRefreshedNewPortalAuth, hasRefreshedAuth);
};
export const setIsUsingOptionalDomain = value => {
  return updateKeyValue(AppKey.IsUsingOptionalDomain, value);
};
export const setIsExistingUserSession = value => {
  return updateKeyValue(AppKey.IsExistingUserSession, value);
};
export const setRedirectUrl = value => {
  return updateKeyValue(AppKey.RedirectUrl, value);
};
export const setIsMicrosoftLoading = value => {
  return updateKeyValue(AppKey.IsMicrosoftLoading, value);
};
export const setWhichOAuthSelected = provider => {
  return updateKeyValue(AppKey.WhichOAuthSelected, provider);
};